import React from 'react';
import { Card, Button } from 'react-bootstrap';
import '../../../assets/css/customer/hotelspages/hotelcard.css';

const HotelCard = ({ hotel, onViewDetails }) => {
  const starRating = "⭐".repeat(hotel.starRating);
  return (
    <Card className="cus-htl-hotel-card">
      <div className="cus-htl-image-container">
        <Card.Img variant="top" src={hotel.image} alt={hotel.name} />
      </div>
      <Card.Body>
        <Card.Title className="cus-htl-hotel-name">{hotel.name}</Card.Title>
        <Card.Text className="cus-htl-hotel-rating">
          {starRating}{hotel.stars}
        </Card.Text>
        <Card.Text className="cus-htl-hotel-location">
          📍 {hotel.location}
        </Card.Text>
        <Card.Text className="cus-htl-hotel-price">
          💰 From Rs.{hotel.price}/night
        </Card.Text>
        <Button 
          className="cus-htl-view-details-btn" 
          onClick={() => onViewDetails(hotel)}
        >
          View Details
        </Button>
      </Card.Body>
    </Card>
  );
};

export default HotelCard;